<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">ユーザー情報確認</h2>

      <UserDataTable :user-detail="userDetail" :office="office" :can-issue-staff-account="true"/>

      <router-link class="yellow-ellipse_button" :to="{name: 'UpdatingUserDetail'}">
        ユーザー情報を編集
      </router-link>
      <router-link v-if="customClaim.isOwner" class="yellow-ellipse_button" :to="{name: 'UpdatingOffice'}">
        事務所情報を編集
      </router-link>
      <router-link class="yellow-ellipse_button" :to="{ name: 'RegisterUserSkill'}">
        スキル & ソフトウェアを編集
      </router-link>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import UserDetail from "@/assets/js/pages/mypage/user/UserDetail";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import UserDataTable from "@/components/objects/table/UserDataTable";

  export default {
    name: "UserDetail",

    components: {UserDataTable},

    mixins: [collection, UserDetail],

    data() {
      return {
        userDetail: {
          skills: {},
        },
        client: {},
        operator: {},
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid', office: 'auth/office', customClaim: 'auth/customClaim'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.getDoc(COLLECTION_NAMES.USER_DETAILS, this.uid).then(async readUserDetail => {
        this.userDetail = readUserDetail;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents();

      > .user-data_block {
        margin-top: 2rem;
        width: 100%;
      }
    }
  }
</style>